module.exports = __webpack_public_path__ + "img/file-icon-orange.06477fa7.svg";